// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__vmmnT","cardHeader":"styles_cardHeader__pcS50"};